import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BriefingPlataformas, getBriefingPlataformasApi } from "../../services/briefingplataforma";
import Box from "@mui/material/Box";
import { appTheme } from "../../styles/tema";
import { Button, CircularProgress, Stack, ThemeProvider } from "@mui/material";
import Typography from "@mui/material/Typography";
import "./SelecionarPlataformaStyles.scss";

interface iMenuItem {
  label: string;
  link: string;
}

const SelecaoPlataforma: React.FC = () => {
  const initial_plataforms: BriefingPlataformas[] = []

  const navigate = useNavigate();
  const [plataformas, setPlataformas] = React.useState<BriefingPlataformas[]>(initial_plataforms);
  const [loading, setLoading] = React.useState(false);

  const getSelecao = () => {
    setLoading(true);
    getBriefingPlataformasApi()
      .then((res) => {
        setPlataformas(res.data)
      }).finally(() => {
        setLoading(false)
      });
  };

  const menuItens: iMenuItem[] = [
    { label: "Users", link: "/users" },
    { label: "Platforms", link: "/platforms" },
  ];

  /** passa o link da pagina como parametro e navega */
  const menuNavigate = (link: string) => {
    navigate(link);
  };

  useEffect(() => {
    getSelecao();
  }, []);

  return (
    <ThemeProvider theme={appTheme} >
      <Box
        component="main"
        maxWidth="sm"
        className="selecionar-plataforma-page"
      >
        <Stack className="header">
          <Typography variant="h4">Drilling rigs</Typography>

          <Box>
            {menuItens.map((item, index) => (
              <Button
                onClick={() => menuNavigate(item.link)}
                variant="contained"
                sx={{ borderRadius: 0, mx: 1 }}
                disableElevation
                key={index}
              >
                {item.label}
              </Button>
            ))}
          </Box>

        </Stack>

        <Box mt="1.5rem" className="rigs">
          {!loading && plataformas ? (
            plataformas.sort((a, b) => { return ('' + a.name).localeCompare(b.name) }).map((briefing) => (
              <Box className="chamfer">
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src="data:image/png;base64,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" ></img>
                </Box>

                <Typography variant="h5" sx={{ gridColumn: "span 2", textAlign: "center", marginTop: 1 }}>
                  {briefing.name}
                </Typography>

                <Box className="content">
                  <Box className="c1">
                    <Typography variant="body1">Well</Typography>
                  </Box>
                  <Box className="c2">
                    <Typography variant="body2">{briefing.well?.name}</Typography>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">Hole depth:</Typography>
                  </Box>
                  <Box className="c2">
                    <Typography variant="body1">{briefing.well?.current_holedepth}</Typography>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">End hole depth:</Typography>
                  </Box>

                  <Box className="c2">
                    <Typography variant="body1">{briefing.well?.end_holedepth}</Typography>
                  </Box>

                  <Box className="subheader">
                    <span title={briefing.section?.name}>Section: {briefing.section?.name}</span>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">Planned:</Typography>
                  </Box>

                  <Box className="c2">
                    <Typography variant="body1">{briefing.section?.planned_duration}</Typography>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">Current:</Typography>
                  </Box>

                  <Box className="c2">
                    <Typography variant="body1">{briefing.section?.current_duration}</Typography>
                  </Box>

                  <Box className="subheader">
                    <span title={briefing.operation?.name}>Operation: {briefing.operation?.name}</span>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">Planned:</Typography>
                  </Box>

                  <Box className="c2">
                    <Typography variant="body1">{briefing.operation?.planned_duration}</Typography>
                  </Box>

                  <Box className="c1">
                    <Typography variant="body1">Current:</Typography>
                  </Box>

                  <Box className="c2">
                    <Typography variant="body1">{briefing.operation?.current_duration}</Typography>
                  </Box>

                  <Button sx={{ gridColumn: "span 2", marginTop: 3 }}
                    variant="contained"
                    href={"/dashboard/?plataforma=" + briefing.db_name}
                  >
                    View dashboard
                  </Button>
                </Box>

                <Typography variant="body2" align="center" >Last update: {briefing.last_update}</Typography>
              </Box>
            ))
          ) : (
            <CircularProgress />
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default SelecaoPlataforma;
